import useStores from 'hooks/use-stores.hooks';

const useAuthentication = () => {
  const { authStore } = useStores();

  return authStore.isAuthenticated;
};

export default useAuthentication;
